/** A header with a trailing link, over a horizontally scrolling rail of `card` cells. */
import { Surface, Vertical } from './primitives';
import { PanelHeader } from './panelHeader';
import { ItemCollection } from './collections';

export function ThumbnailShelf({ nodeId, node, props = {}, data, ctx, emit, slots, renderTemplate }) {
  return (
    <Surface variant="card" props={{ padding: '4', radius: 28 }}>
      <Vertical props={{ gap: '3' }}>
        <PanelHeader
          title={props.title}
          action={props.action}
          onAction={() => emit?.('actionActivated', {
            action: props.action?.action || props.action?.label || null,
          })}
        />
        <ItemCollection
          nodeId={nodeId}
          node={node}
          props={{
            layout: 'rail',
            columns: 3,
            aspect: props.aspect ?? '1/1',
            width: props.width,
            gap: '3',
            items: props.items,
            card: props.card,
            pending: props.pending,
            crud: props.crud,
            pendingScope: props.pendingScope,
            emptyTitle: props.emptyTitle,
            emptyBody: props.emptyBody,
          }}
          data={data}
          ctx={ctx}
          emit={emit}
          slots={slots}
          renderTemplate={renderTemplate || props.renderTemplate}
        />
      </Vertical>
    </Surface>
  );
}

export default ThumbnailShelf;
